import { http, HttpResponse } from 'msw';

// Aligns with backend `UserOut` + `GET /admin/auth/me`
const mockProfile = {
  id: '00000000-0000-0000-0000-000000000001',
  email: 'john.doe@example.com',
  full_name: 'John Doe',
  role: 'admin',
  is_active: true,
};

// Mock notification settings
const mockNotificationSettings = {
  type: 'all' as const,
  communicationEmails: true,
  marketingEmails: false,
  securityEmails: true,
};

export const settingsHandlers = [
  http.get('*/admin/auth/me', () => {
    return HttpResponse.json({
      status: true,
      status_code: 200,
      message: 'OK',
      data: mockProfile,
      error: null,
    });
  }),

  http.put('*/settings/profile', async ({ request }) => {
    const data = await request.json();
    const updatedProfile = {
      ...mockProfile,
      ...(typeof data === 'object' && data !== null ? data : {}),
    };
    return HttpResponse.json({ data: updatedProfile });
  }),

  // POST /admin/auth/change-password — same envelope as backend `error_response`
  http.post('*/admin/auth/change-password', async ({ request }) => {
    const data = (await request.json()) as {
      old_password?: string;
      new_password?: string;
    };

    if (data.old_password !== 'current123') {
      return HttpResponse.json(
        {
          detail: {
            success: false,
            status_code: 400,
            message: 'Current password is incorrect',
            error: null,
            data: null,
          },
        },
        { status: 400 }
      );
    }

    if ((data.new_password?.length ?? 0) < 8) {
      return HttpResponse.json(
        {
          detail: {
            success: false,
            status_code: 400,
            message: 'New password must be at least 8 characters',
            error: null,
            data: null,
          },
        },
        { status: 400 }
      );
    }

    return HttpResponse.json({
      status: true,
      status_code: 200,
      message: 'Password updated',
      data: null,
      error: null,
    });
  }),

  // Get notification settings
  http.get('*/settings/notifications', () => {
    return HttpResponse.json({ data: mockNotificationSettings });
  }),

  // Update notification settings
  http.put('*/settings/notifications', async ({ request }) => {
    const data = await request.json();
    const updatedSettings = {
      ...mockNotificationSettings,
      ...(typeof data === 'object' && data !== null ? data : {})
    };
    return HttpResponse.json({ data: updatedSettings });
  }),
];
